import { IonContent } from "@ionic/react";
import { modal_id_privacy } from "../../../context/OpenModalContext/modal_ids";
import { useOpenModal } from "../../../context/OpenModalContext/OpenModalContext";
import strings from "../../../localization/localization";

import styles from "./content.module.css";

const Content = () => {
  const { closeModal } = useOpenModal();
  return (
    <IonContent>
      
        <div className={styles.header}>
        <ion-icon
          name="close"
          class={styles.closing}
          onClick={() => closeModal(modal_id_privacy)}
        ></ion-icon>
        <h1 className={styles.title}>{strings.privacy_menu}</h1>
        </div>
        <div className={styles.privacySection}>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
        <p className={styles.answer}>
          Thank you for choosing to be part of our community at
          <span className={styles.name}> noytrall</span>. We are committed to
          protecting your personal information and your right to privacy.
        </p>
        <p className={styles.answer}>
          If you have any questions or concerns about this privacy notice, or
          our practices with regards to your personal information, please
          contact us at <span className={styles.name}> social@noytrall.pt</span>
        </p>

        <p className={styles.answer}>
          When you use our mobile application, as the case may be (the "App")
          and more generally, use any of our services (the "Services", which
          include the App), we appreciate that you are trusting us with your
          personal information. We take your privacy very seriously. In this
          privacy notice, we seek to explain to you in the clearest way possible
          what information we collect, how we use it and what rights you have in
          relation to it. We hope you take some time to read through it
          carefully, as it is important. If there are any terms in this privacy
          notice that you do not agree with, please discontinue use of our
          Services immediately.
        </p>
  
        <p className={styles.answer}>
          This privacy notice applies to all information collected through our
          Services (which, as described above, includes our App), as well as any
          related services, sales, marketing or events.
        </p>
    
        <p className={styles.answer}>
          <strong>
            Please read this privacy notice carefully as it will help you
            understand what we do with the information that we collect.
          </strong>
        </p>
        <hr className={styles.line} />
        <h2 className={styles.contentTitle}>TABLE OF CONTENTS</h2>
        <ol>
          <li className={styles.indice}>
            <a href="#tableofcontents1" className={styles.indice}>
              What information do we collect?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents2" className={styles.indice}>
              How do we use your information?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents3" className={styles.indice}>
              Will your information be shared with anyone?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents4" className={styles.indice}>
              How do we handle your social logins?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents5" className={styles.indice}>
              How long do we keep your information?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents6" className={styles.indice}>
              Do we collect information from minors?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents7" className={styles.indice}>
              What are your provacy rights?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents8" className={styles.indice}>
              Controls for do-not-track features
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents9" className={styles.indice}>
              Do California residents have specific privacy rights?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents11" className={styles.indice}>
              Do we make updates to this notice?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents12" className={styles.indice}>
              How can you contact us about this notice?
            </a>
          </li>
          <li className={styles.indice}>
            <a href="#tableofcontents13" className={styles.indice}>
              How can you review, update, or delete the data we collect from
              you?
            </a>
          </li>
        </ol>
       
        <hr className={styles.line} />
     
        <h3 id="tableofcontents1" className={styles.contentTitle}>
          1. What information do we collect?
        </h3>
        <h4 className={styles.answer}>
          <strong>Personal information you disclose to us</strong>
        </h4>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>We collect personal information that you provide to us.</em>
        </p>
        <p className={styles.answer}>
          We collect personal information that you voluntarily provide to us
          when you register on the App express an interest in obtaining
          information about us or our products and services, when you
          participate in activities on the App (such as by posting messages in
          our online forums or entering competitions, contests or giveaways) or
          otherwise when you contact us.
        </p>
        <p className={styles.answer}>
          The personal information that we collect depends on the context of
          your interactions with us and the App, the choices you make and the
          products and features you use. The personal information we collect may
          include the following:
        </p>
        <p className={styles.answer}>
          <strong>Personal Information Provided by You.</strong> We collect
          names, email addresses, usernames, passwords, and other similar
          information.
        </p>
        <p className={styles.answer}>
          <strong>Social Media Login Data.</strong> We may provide you with the
          option to register with us using your existing social media account
          details, like your Facebook, Twitter or other social media account. If
          you choose to register in this way, we will collect the information
          described in the section called "
          <a href="#tableofcontents4" className={styles.indice}>
            How do we handle social logins
          </a>
          " below.
        </p>
        <p className={styles.answer}>
          All personal information that you provide to us must be true, complete
          and accurate, and you must notify us of any changes to such personal
          information.
        </p>
        <h4 className={styles.answer}>
          <strong>Information automatically collected</strong>
        </h4>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>
            Some information such as your Internet Protocol (IP) address and/or
            browser and device characteristics is collected automatically when
            you visit our App.
          </em>
        </p>
        <p className={styles.answer}>
          We automatically collect certain information when you visit, use or
          navigate the App. This information does not reveal your specific
          identity (like your name or contact information) but may include
          device and usage information, such as your IP address, browser and
          device characteristics, operating system, language preferences,
          referring URLs, device name, country, location, information about how
          and when you use our App and other technical information. This
          information is primarily needed to maintain the security and operation
          of our App, and for our internal analytics and reporting purposes.
        </p>
        <p className={styles.answer}>The information we collect includes:</p>
        <ul>
          <li className={styles.answer}>
            Log and Usage Data. Log and usage data is service-related,
            diagnostic, usage and performance information our servers
            automatically collect when you access or use our App and which we
            record in log files. Depending on how you interact with us, this log
            data may include your IP address, device information, browser type
            and settings and information about your activity in the App (such as
            the date/time stamps associated with your usage, pages and files
            viewed, searches and other actions you take such as which features
            you use), device event information (such as system activity, error
            reports (sometimes called 'crash dumps') and hardware settings).
          </li>
        </ul>
      
        <hr className={styles.line} />
     
        <h3 id="tableofcontents2" className={styles.contentTitle}>
          2. How do we use your information?
        </h3>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>
            We process your information for purposes based on legitimate
            business interests, the fulfillment of our contract with you,
            compliance with our legal obligations, and/or your consent.
          </em>
        </p>
        <p className={styles.answer}>
          We use personal information collected via our App for a variety of
          business purposes described below. We process your personal
          information for these purposes in reliance on our legitimate business
          interests, in order to enter into or perform a contract with you, with
          your consent, and/or for compliance with our legal obligations. We
          indicate the specific processing grounds we rely on next to each
          purpose listed below. We use the information we collect or receive:
        </p>
        <ul>
          <li className={styles.answer}>
            <strong>To facilitate account creation and logon process. </strong>
            If you choose to link your account with us to a third-party account
            (such as your Google or Facebook account), we use the information
            you allowed us to collect from those third parties to facilitate
            account creation and logon process for the performance of the
            contract. See the section below headed "
            <a href="#tableofcontents4" className={styles.indice}>
              How do we handle social logins
            </a>
            " for further information.
          </li>
          <li className={styles.answer}>
            <strong>To post testimonials.</strong>
            We post testimonials on our App that may contain personal
            information. Prior to posting a testimonial, we will obtain your
            consent to use your name and the content of the testimonial. If you
            wish to update, or delete your testimonial, please contact us at
            <span className={styles.name}> social@noytrall.pt</span> and be sure
            to include your name, testimonial location, and contact information.
          </li>
          <li className={styles.answer}>
            <strong>Request feedback.</strong>
            We may use your information to request feedback and to contact you
            about your use of our App.
          </li>
          <li className={styles.answer}>
            <strong>To enable user-to-user communications.</strong>
            We may use your information in order to enable user-to-user
            communications with each user's consent.
          </li>
          <li className={styles.answer}>
            <strong>To manage user accounts.</strong>
            We may use your information for the purposes of managing our account
            and keeping it in working order.
          </li>
        </ul>
      
        <hr className={styles.line} />
       
        <h3 id="tableofcontents3" className={styles.contentTitle}>
          3. Will your information be shared with anyone?
        </h3>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>
            We only share information with your consent, to comply with laws, to
            provide you with services, to protect your rights, or to fulfill
            business obligations.
          </em>
        </p>
        <p className={styles.answer}>
          We may process or share your data that we hold based on the following
          legal basis:
        </p>
        <ul>
          <li className={styles.answer}>
            <strong>Consent:</strong>
            We may process your data if you have given us specific consent to
            use your personal information for a specific purpose.
          </li>
          <li className={styles.answer}>
            <strong>Legitimate Interests:</strong>
            We may process your data when it is reasonably necessary to achieve
            our legitimate business interests.
          </li>
          <li className={styles.answer}>
            <strong>Performance of a Contract:</strong>
            Where we have entered into a contract with you, we may process your
            personal information to fulfill the terms of our contract.
          </li>
          <li className={styles.answer}>
            <strong>Legal Obligations:</strong>
            We may disclose your information where we are legally required to do
            so in order to comply with applicable law, governmental requests, a
            judicial proceeding, court order, or legal process, such as in
            response to a court order or a subpoena (including in response to
            public authorities to meet national security or law enforcement
            requirements).
          </li>
          <li className={styles.answer}>
            <strong>Vital Interests:</strong>
            We may disclose your information where we believe it is necessary to
            investigate, prevent, or take action regarding potential violations
            of our policies, suspected fraud, situations involving potential
            threats to the safety of any person and illegal activities, or as
            evidence in litigation in which we are involved.
          </li>
        </ul>
        <p className={styles.answer}>
          More specifically, we may need to process your data or share your
          personal information in the following situations:
        </p>
        <ul>
          <li className={styles.answer}>
            <strong>Business Transfers.</strong>
            We may share or transfer your information in connection with, or
            during negotiations of, any merger, sale of company assets,
            financing, or acquisition of all or a portion of our business to
            another company.
          </li>
          <li className={styles.answer}>
            <strong>Business Partners.</strong>
            We may share your information with our business partners to offer
            you certain products, services or promotions.
          </li>
          <li className={styles.answer}>
            <strong>Other Users.</strong>
            When you share personal information or otherwise interact with
            public areas of the App, such personal information may be viewed by
            all users and may be publicly made available outside the App in
            perpetuity. If you interact with other users of our App and register
            for our App through a social network (such as Facebook), your
            contacts on the social network will see your name, profile photo,
            and descriptions of your activity. Similarly, other users will be
            able to view descriptions of your activity, communicate with you
            within our App, and view your profile.
          </li>
        </ul>
     
        <hr className={styles.line} />
      
        <h3 id="tableofcontents4" className={styles.contentTitle}>
          4. How do we handle your social logins?
        </h3>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>
            If you choose to register or log in to our services using a social
            media account, we may have access to certain information about you.
          </em>
        </p>
        <p className={styles.answer}>
          Our App offers you the ability to register and login using your
          third-party social media account details (like your Facebook or
          Twitter logins). Where you choose to do this, we will receive certain
          profile information about you from your social media provider. The
          profile information we receive may vary depending on the social media
          provider concerned, but will often include your name, email address,
          friends list, profile picture as well as other information you choose
          to make public on such social media platform.
        </p>
        <p className={styles.answer}>
          We will use the information we receive only for the purposes that are
          described in this privacy notice or that are otherwise made clear to
          you on the relevant App. Please note that we do not control, and are
          not responsible for, other uses of your personal information by your
          third-party social media provider. We recommend that you review their
          privacy notice to understand how they collect, use and share your
          personal information, and how you can set your privacy preferences on
          their sites and apps.
        </p>
      
        <hr className={styles.line} />
      
        <h3 id="tableofcontents5" className={styles.contentTitle}>
          5. How long do we keep your information?
        </h3>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>
            We keep your information for as long as necessary to fulfill the
            purposes outlined in this privacy notice unless otherwise required
            by law.
          </em>
        </p>
        <p className={styles.answer}>
          We will only keep your personal information for as long as it is
          necessary for the purposes set out in this privacy notice, unless a
          longer retention period is required or permitted by law (such as tax,
          accounting or other legal requirements). No purpose in this notice
          will require us keeping your personal information for longer than the
          period of time in which users have an account with us.
        </p>
        <p className={styles.answer}>
          When we have no ongoing legitimate business need to process your
          personal information, we will either delete or anonymize such
          information, or, if this is not possible (for example, because your
          personal information has been stored in backup archives), then we will
          securely store your personal information and isolate it from any
          further processing until deletion is possible.
        </p>
       
        <hr className={styles.line} />
       
        <h3 id="tableofcontents6" className={styles.contentTitle}>
          6. Do we collect information from minors?
        </h3>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>
            We do not knowingly collect data from or market to children under 18
            years of age.
          </em>
        </p>
        <p className={styles.answer}>
          We do not knowingly solicit data from or market to children under 18
          years of age. By using the App, you represent that you are at least 18
          or that you are the parent or guardian of such a minor and consent to
          such minor dependents use of the App. If we learn that personal
          information from users less than 18 years of age has been collected,
          we will deactivate the account and take reasonable measures to
          promptly delete such data from our records. If you become aware of any
          data we may have collected from children under age 18, please contact
          us at <span className={styles.name}>social@noytrall.pt</span>.
        </p>
       
        <hr className={styles.line} />
      
        <h3 id="tableofcontents7" className={styles.contentTitle}>
          7. What are your privacy rights?
        </h3>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>
            In some regions, such as the European Economic Area, you have rights
            that allow you greater access to and control over your personal
            information. You may review, change, or terminate your account at
            any time.
          </em>
        </p>
        <p className={styles.answer}>
          In some regions (like the European Economic Area), you have certain
          rights under applicable data protection laws. These may include the
          right (i) to request access and obtain a copy of your personal
          information, (ii) to request rectification or erasure; (iii) to
          restrict the processing of your personal information; and (iv) if
          applicable, to data portability. In certain circumstances, you may
          also have the right to object to the processing of your personal
          information. To make such a request, please use the
          <a href="#tableofcontents12" className={styles.indice}>
            contact details
          </a>
          provided below. We will consider and act upon any request in
          accordance with applicable data protection laws.
        </p>
        <p className={styles.answer}>
          If we are relying on your consent to process your personal
          information, you have the right to withdraw your consent at any time.
          Please note however that this will not affect the lawfulness of the
          processing before its withdrawal, nor will it affect the processing of
          your personal information conducted in reliance on lawful processing
          grounds other than consent.
        </p>
        <p className={styles.answer}>
          If you are a resident in the European Economic Area and you believe we
          are unlawfully processing your personal information, you also have the
          right to complain to your local data protection supervisory authority.
          You can find their contact details here:
          <a
            className={styles.indice}
            href="http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm"
            target="_blank"
            rel="noreferrer"
          >
            http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm
          </a>
          .
        </p>
        <p className={styles.answer}>
          If you are a resident in Switzerland, the contact details for the data
          protection authorities are available here:
          <a
            className={styles.indice}
            href="https://www.edoeb.admin.ch/edoeb/en/home.html"
            target="_blank"
            rel="noreferrer"
          >
            https://www.edoeb.admin.ch/edoeb/en/home.html
          </a>
          .
        </p>
        <p className={styles.answer}>
          If you have questions or comments about your privacy rights, you may
          email us at <span className={styles.name}>social@noytrall.pt</span>.
        </p>
        <h4 className={styles.answer}>
          <strong>Account Information</strong>
        </h4>
        <p className={styles.answer}>
          If you would at any time like to review or change the information in
          your account or terminate your account, you can:
        </p>
        <ul>
          <li className={styles.answer}>
            Contact us using the contact information provided.
          </li>
        </ul>
        <p className={styles.answer}>
          Upon your request to terminate your account, we will deactivate or
          delete your account and information from our active databases.
          However, we may retain some information in our files to prevent fraud,
          troubleshoot problems, assist with any investigations, enforce our
          Terms of Use and/or comply with applicable legal requirements.
        </p>
        <p className={styles.answer}>
          <strong>
            <u>Opting out of email marketing: </u>
          </strong>
          You can unsubscribe from our marketing email list at any time by
          clicking on the unsubscribe link in the emails that we send or by
          contacting us using the details provided below. You will then be
          removed from the marketing email list, however, we may still
          communicate with you, for example to send you service-related emails
          that are necessary for the administration and use of your account, to
          respond to service requests, or for other non-marketing purposes. To
          otherwise opt-out, you may:
        </p>
        <ul>
          <li className={styles.answer}>
            Contact us using the contact information provided.
          </li>
        </ul>
      
        <hr className={styles.line} />
      
        <h3 id="tableofcontents8" className={styles.contentTitle}>
          8. Controls for do-not-track features
        </h3>
        <p className={styles.answer}>
          Most web browsers and some mobile operating systems and mobile
          applications include a Do-Not-Track ("DNT") feature or setting you can
          activate to signal your privacy preference not to have data about your
          online browsing activities monitored and collected. At this stage no
          uniform technology standard for recognizing and implementing DNT
          signals has been finalized. As such, we do not currently respond to
          DNT browser signals or any other mechanism that automatically
          communicates your choice not to be tracked online. If a standard for
          online tracking is adopted that we must follow in the future, we will
          inform you about that practice in a revised version of this privacy
          notice.
        </p>
       
        <hr className={styles.line} />
    
        <h3 id="tableofcontents9" className={styles.contentTitle}>
          9. Do California residents have specific privacy rights?
        </h3>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>
            Yes, if you are a resident of California, you are granted specific
            rights regarding access to your personal information.
          </em>
        </p>
        <p className={styles.answer}>
          California Civil Code Section 1798.83, also known as the "Shine The
          Light" law, permits our users who are California residents to request
          and obtain from us, once a year and free of charge, information about
          categories of personal information (if any) we disclosed to third
          parties for direct marketing purposes and the names and addresses of
          all third parties with which we shared personal information in the
          immediately preceding calendar year. If you are a California resident
          and would like to make such a request, please submit your request in
          writing to us using the contact information provided below.
        </p>
        <p className={styles.answer}>
          If you are under 18 years of age, reside in California, and have a
          registered account with the App, you have the right to request removal
          of unwanted data that you publicly post on the App. To request removal
          of such data, please contact us using the contact information provided
          below, and include the email address associated with your account and
          a statement that you reside in California. We will make sure the data
          is not publicly displayed on the App, but please be aware that the
          data may not be completely or comprehensively removed from all our
          systems (e.g. backups, etc.).
        </p>
      
        <hr className={styles.line} />
       
        <h3 id="tableofcontents11" className={styles.contentTitle}>
          10. Do we make updates to this notice?
        </h3>
        <p className={styles.answer}>
          <strong>In Short: </strong>
          <em>
            Yes, we will update this notice as necessary to stay compliant with
            relevant laws.
          </em>
        </p>
        <p className={styles.answer}>
          We may update this privacy notice from time to time. The updated
          version will be indicated by an updated "Revised" date and the updated
          version will be effective as soon as it is accessible. If we make
          material changes to this privacy notice, we may notify you either by
          prominently posting a notice of such changes or by directly sending
          you a notification. We encourage you to review this privacy notice
          frequently to be informed of how we are protecting your information.
        </p>
       
        <hr className={styles.line} />
    
        <h3 id="tableofcontents12" className={styles.contentTitle}>
          11. How can you contact us about this notice?
        </h3>
        <p className={styles.answer}>
          If you have questions or comments about this notice, you may email us
          at
          <span className={styles.name}>social@noytrall.pt</span> or by post to:
        </p>
        <p className={styles.answer}>
          <span className={styles.name}>noytrall</span>
        </p>
        <p className={styles.answer}>Instituto Pedro Nunes</p>
        <p className={styles.answer}>Rua Pedro Nunes Coimbra</p>
        <p className={styles.answer}>Coimbra, Coimbra 3030-199</p>
        <p className={styles.answer}>Portugal</p>
       
        <hr className={styles.line} />
       
        <h3 id="tableofcontents13" className={styles.contentTitle}>
          12. How can you review, update, or delete the data we collect from
          you? C
        </h3>
        <p className={styles.answer}>
          Based on the applicable laws of your country, you may have the right
          to request access to the personal information we collect from you,
          change that information, or delete it in some circumstances. To
          request to review, update, or delete your personal information, please
          submit a request form by clicking
          <a
            className={styles.indice}
            href="https://app.termly.io/notify/959d7c15-e359-4e3a-b8fa-8c046e890c88"
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
          . We will respond to your request within 30 days.
        </p>
        <p className={styles.answer}>
          This privacy policy was created using
          <a
            className={styles.indice}
            href="https://termly.io/products/privacy-policy-generator/?ftseo"
            target="_blank"
            rel="noreferrer"
          >
            Termly Privacy Policy Generator
          </a>
          .
        </p>
      </div>
    </IonContent>
  );
};

export default Content;
